import * as React from 'react';
import { MenuConfig } from '@tencent/workbench';
import { arrange } from '@editor/src/js/constants/toolbar-data';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';

export const config = arrange.dropdown.data[3];

export const INSERT_TEXT_MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        tooltip: config.content,
        icon: <img src={config.icon} alt={''}/>,
    },
    {
        name: ActionType.BASE_DOWN,
        content: i18n.t<string>('置底'),
        tooltip: i18n.t<string>('置底'),
    },
];
